import React, { useState } from "react";
import Standard from "./Standard";
import styles from "./Popup.module.css";
import Button from "../../../components/Button";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { LeagueResult, StatusTypes } from "@chesshotel/constants";
import { ResultTypes } from "@chesshotel/constants";
// import { updateLeagueResult } from "../../../ducks/leagues";

import NewLeague from "./NewLeague";
// import { useUser } from "../../../ducks/user";
// import { gaEvent } from "../../../lib/ga";

// let variant = null;

export default function LeaguePopup({
  onClose,
  result,
  status,
  leagueScoreResult,
}) {
  const { t } = useTranslation("common");
  const router = useRouter();

  const { leagueScore, rank } = leagueScoreResult;
  const { leagueName, modeId } = leagueScore;

  const [leagueResult, setLeagueResult] = useState(
    leagueScoreResult.leagueResult
  );

  // const { isGuest } = useUser();

  const [visible, setVisible] = useState("show");

  // function runABTest(testId: string, event: string) {
  //   if (window.dataLayer) {
  //     window.dataLayer.push({ event });
  //   }
  //   const intervalId = setInterval(() => {
  //     if (window.google_optimize !== undefined) {
  //       variant = window.google_optimize.get(testId);
  //       console.log("Sign up variant", variant);
  //       clearInterval(intervalId);
  //     }
  //   }, 100);
  // }

  // useEffect(() => {
  //   if (gameNr === 3 && variant == null && isGuest) {
  //     runABTest("-IrAeE1gQPWc184sDl9ZYQ", "optimize.sign_up5");
  //   }
  // }, [gameNr]);

  const hide = () => {
    setVisible("hide");
    setTimeout(() => {
      onClose();
    }, 600);
  };

  let resultText: string;
  let loserColor: string;
  if (result === ResultTypes.WHITE_WINNS) {
    resultText = t("White wins") + "!";
    loserColor = t("Black");
  } else if (result === ResultTypes.BLACK_WINNS) {
    resultText = t("Black wins") + "!";
    loserColor = t("White");
  } else if (status === StatusTypes.ABORT) {
    resultText = t("Game aborted");
  } else {
    resultText = t("Draw");
  }

  let statusMsg = "";
  switch (status) {
    case StatusTypes.TIME_UP:
      statusMsg = t("On time");
      break;
    case StatusTypes.QUIT:
      statusMsg = t("playerLeftGame", { player: loserColor });
      break;
    case StatusTypes.CHECK_MATE:
      statusMsg = t("Checkmate!");
      break;
    case StatusTypes.RESIGN:
      statusMsg = t("playerResigned", { player: loserColor });
      break;
    case StatusTypes.STALE_MATE:
      statusMsg = t("Stalemate!");
      break;
    case StatusTypes.DRAW:
      statusMsg = "";
      break;
    case StatusTypes.THREEFOLD_REPETITION:
      statusMsg = t("Threefold repetition");
      break;
    case StatusTypes.ABORT:
      statusMsg = "";
      break;
    default:
      statusMsg = null;
  }

  function renderBody() {
    if (
      leagueResult === LeagueResult.STANDARD ||
      leagueResult === LeagueResult.PLACEMENT
    ) {
      return <Standard leagueScoreResult={leagueScoreResult} />;
    } else {
      return (
        <NewLeague
          leagueResult={leagueResult}
          rank={rank}
          modeId={modeId}
          leagueName={leagueName}
        />
      );
    }
  }

  function renderButtons() {
    if (leagueResult === LeagueResult.STANDARD) {
      // if (gameNr >= 4 && isGuest && variant == "1") {
      //   return (
      //     <div className="flex flex-col items-center space-y-5">
      //       <div className="font-semibold">
      //         {t("Sign up to save your progress")}
      //       </div>
      //       <div className="flex items-center space-x-4">
      //         <Button onClick={() => hide()} color="white" size="medium">
      //           {t("Close")}
      //         </Button>
      //         <Button
      //           onClick={() => {
      //             gaEvent({
      //               category: "SignUpBanner",
      //               action: "Sign up",
      //               label: username,
      //             });
      //             router.push("/register");
      //           }}
      //           color="brightBlue"
      //           size="medium"
      //         >
      //           {t("Sign up")}
      //         </Button>
      //       </div>
      //     </div>
      //   );
      // } else if (gameNr >= 4 && isGuest && variant == "2") {
      //   return (
      //     <div className="flex flex-col items-center space-y-5">
      //       <div className="font-semibold">
      //         {t("Sign up to save your progress")}
      //       </div>
      //       <div className="flex items-center space-x-4">
      //         <Button
      //           onClick={() => hide()}
      //           color="white"
      //           size={isDesktop ? "medium" : "small"}
      //         >
      //           {t("Close")}
      //         </Button>
      //         <Button
      //           onClick={() => router.push("/leagues/" + modeId)}
      //           color="white"
      //           size={isDesktop ? "medium" : "small"}
      //         >
      //           {t("League tables")}
      //         </Button>
      //         <Button
      //           onClick={() => {
      //             gaEvent({
      //               category: "SignUpBanner",
      //               action: "Sign up",
      //               label: username,
      //             });
      //             router.push("/register");
      //           }}
      //           color="brightBlue"
      //           size={isDesktop ? "medium" : "small"}
      //         >
      //           {t("Sign up")}
      //         </Button>
      //       </div>
      //     </div>
      //   );
      // } else {
      return (
        <>
          <Button onClick={() => hide()} color="white" size="medium">
            {t("Close")}
          </Button>
          <Button
            onClick={() => router.push("/leagues/" + modeId)}
            color="brightBlue"
            size="medium"
          >
            {t("League tables")}
          </Button>
        </>
      );
      // }
    } else if (leagueResult === LeagueResult.PLACEMENT) {
      return (
        <Button onClick={() => hide()} color="white" size="medium">
          {t("Close")}
        </Button>
      );
    } else {
      return (
        <Button
          onClick={() => setLeagueResult(LeagueResult.STANDARD)}
          color="brightBlue"
          size="medium"
        >
          {t("Continue")}
        </Button>
      );
    }
  }

  return (
    <div className={styles.cont + " " + styles[visible]}>
      <div className={styles.overlay} onClick={hide}></div>
      <div className={styles.popup}>
        {onClose && (
          <div className={styles.close} onClick={hide}>
            ×
          </div>
        )}

        <div className="flex flex-col self-start w-full py-3 pl-5 border-b md:pl-6">
          <div className="flex flex-col text-lg font-semibold md:text-xl">
            {resultText}
          </div>
          <div className="text-xs md:text-sm">{statusMsg}</div>
        </div>
        <div className="flex flex-col items-center w-full bg-white">
          {renderBody()}
        </div>
        <div className={styles.buttonsCont}>{renderButtons()}</div>
      </div>
    </div>
  );
}
